<template>
  <div id="app">
    <el-container>
      <el-header height="110px">
        <el-row>
          <el-col :xs="18" :sm="18" :md="10" :lg="10" :xl="10">
            <div class="logo">
              <img class="logo" src="./assets/images/logo.png" />
              <div class="logoTitle">
                <span>中国</span>
              </div>
            </div>
          </el-col>
          <el-col align="right" :xs="4" :sm="4" :md="12" :lg="12" :xl="12" style="padding: 20px" >
            <el-menu ref="mainMenu" :default-active="'/' + $route.path.split('/')[1]" class="el-menu-demo" mode="horizontal" border-bottom="none"  v-if = "!isXs"  :index = "'/'+ $route.path.split('/')[1]" @select="handleSelect()" router >
               <el-menu-item v-for="(item,index) in navMenu" :key="index" :index = "item.path" >
                 {{item.title}}
               </el-menu-item>
<!--
                <el-menu-item index="1">首页</el-menu-item>
                <el-menu-item index="2">品牌之路</el-menu-item>
                <el-menu-item index="3">产品价值</el-menu-item>
                <el-menu-item index="4" >服务</el-menu-item>
                <el-menu-item index="5">商城</el-menu-item>
                <el-menu-item index="6">博客</el-menu-item>
                <el-menu-item index="7">联系</el-menu-item>
-->
            </el-menu>
            <el-menu :default-active="'/'+ $route.path.split('/')[1]" :index = "'/'+ $route.path.split('/')[1]" router :collapse =true>
              <el-submenu
                style="float:right;"
                class="right-item"
                v-if = "isXs"
                index="100"
                :collapse =true
                >
                <template slot="title">
                  <i class="el-icon-s-fold" style="font-size:28px;color:#2d2d2d;"></i>
                </template>
                <el-menu-item v-for="(item,index) in navMenu" :key="index + 10" :index = "item.path"  >
                  {{item.title}}
                </el-menu-item>
<!--             <el-menu-item index="1">首页</el-menu-item>
                <el-menu-item index="2">品牌之路</el-menu-item>
                <el-menu-item index="3">产品价值</el-menu-item>
                <el-menu-item index="4" >服务</el-menu-item>
                <el-menu-item index="5">商城</el-menu-item>
                <el-menu-item index="6" >联系</el-menu-item>
                 -->
              </el-submenu>
            </el-menu>
          </el-col>
          <el-col :xs="4" :sm="4" :md="2" :lg="2" :xl="2" style="padding: 40px 0 0 0">

            <el-tooltip :content="userName" placement="top">
              <div><i v-if = "userName==''?false:true" class="el-icon-user"></i></div>
            </el-tooltip>
            <!--
            <ul v-if = "userName==''?true:false" class="user-zone"  style="font-size: 14px">
              <li><a @click="dialogLogVisible = true">登录</a></li>
              <li>|</li>
              <li><a @click="dialogRegVisible=true">注册</a></li>
            </ul>
            -->
          </el-col>

        </el-row>
      </el-header>
      <el-main>
        <router-view />

      </el-main>
      <el-footer>
          <ft/>

      </el-footer>
    </el-container>
    <el-dialog   title="用户登录" :visible.sync="dialogLogVisible" style="width: 40%;margin: auto;text-align: left">
      <el-form ref ="logDlg" :model="logForm" style="margin-left: -50px" :rules="rules1">
        <el-form-item label="用户名" :label-width="formLabelWidth" prop="userName">
          <el-input v-model="logForm.userName" autocomplete="off" placeholder="请输入用户名" ></el-input>
        </el-form-item>
        <el-form-item label="密码" :label-width="formLabelWidth" prop="password">
          <el-input type="password" v-model="logForm.password" placeholder="请输入密码">
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogLogVisible = false">取 消</el-button>
        <el-button type="primary" @click="login()">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog  title="用户注册" :visible.sync="dialogRegVisible">
      <el-form ref ="regDlg" :model="regForm" :rules="rules2">
        <el-form-item label="用户名" :label-width="formLabelWidth" prop="userName">
          <el-input v-model="regForm.userName" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="密码" :label-width="formLabelWidth" prop="password">
          <el-input type="password" v-model="regForm.password" placeholder="请输入密码">
          </el-input>
        </el-form-item>
        <el-form-item label="确认密码" :label-width="formLabelWidth" prop="password2">
          <el-input type="password" v-model="regForm.password2" placeholder="请再次输入密码">
          </el-input>
        </el-form-item>
        <el-form-item label="电子邮箱" :label-width="formLabelWidth" prop="userEmail">
          <el-input v-model="regForm.userEmail" placeholder="请输入邮箱">
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogRegVisible = false">取 消</el-button>
        <el-button type="primary" @click="regUser()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import router from './router'
import './assets/icomoon/style.css'
import ft from './components/webfooter'
export default {
  name: 'App',
  components: {
    ft
  },
  data () {
    const validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.regForm.password) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      // router: router,
      path: '',
      navMenu: [
        {
          title: '首页',
          path: '/',
          hasChildren: false
        },
        {
          title: '品牌之路',
          path: '/brand',
          hasChildren: false
        },
        {
          title: '产品价值',
          path: '/benifit',
          hasChildren: false
        },
        {
          title: '服务',
          path: '/service',
          hasChildren: false
        },
        {
          title: '商城',
          path: '/shop',
          hasChildren: false
        },
        {
          title: '博客',
          path: '/blog',
          hasChildren: false
        },
        {
          title: '联系',
          path: '/contact',
          hasChildren: false
        }
      ],
      activeIndex: '0',
      screenWidth: document.body.clientWidth,
      userName: '',
      dialogLogVisible: false,
      dialogRegVisible: false,
      formLabelWidth: '120px',
      logForm: {
        userName: '',
        password: ''
      },
      regForm: {
        userName: '',
        password: '',
        password2: '',
        userEmail: '',
        userStop: false
      },
      rules1: {
        userName: [{ required: true, message: '请输入姓名！', trigger: 'blur' }],
        password: [{required: true, message: '密码不能为空！', trigger: 'blur'}]
      },
      rules2: {
        userName: [{ required: true, message: '请输入姓名！', trigger: 'blur' }],
        password: [{required: true, message: '密码不能为空！', trigger: 'blur'}],
        password2: [{required: true, validator: validatePass2, trigger: 'blur'}],
        userEmail: [
          {
            required: true, message: '请输入邮箱！', trigger: 'blur'
          },
          {
            type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change']
          }
        ]
      }
    }
  },
  created () {
    // this.onRouteChanged()
  },
  methods: {
    onRouteChanged () {
      let that = this
      that.path = that.$route.path
      // alert(this.$refs.mainMenu)
      // this.$refs.mainMenu.activeIndex = that.path
    },
    handleSelect () {
      return 0
    },
    menuRefresh (path) {
      this.$refs.mainMenu.activeIndex = path
    },
    openFullScreen2 () {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-eleme', // 'icon-image2vector path1 ', // 'el-icon-eleme', //  'el-icon-loading'
        background: 'rgba(0, 0, 0, 0.7)'
      })
      setTimeout(() => {
        loading.close()
      }, 2000)
    },
    login () {
      this.$refs.logDlg.validate((valid) => {
        if (valid) {
          this.dialogLogVisible = false
          this.axios.post('http://119.45.63.83:3000/users/login', this.logForm).then((res) => {
            console.log(res)
            if (res.status === 200) {
              if (res.data.status === 100) {
                console.log('suc')
                this.$alert('登录成功', '用户登录')
                this.userName = res.data.data.user[0].userName
              } else {
                this.$alert('用户名或者密码错误', '用户登录')
              }
            }
          })
        }
      })
    },
    regUser () {
      this.$refs.regDlg.validate((valid) => {
        if (valid) {
          this.dialogRegVisible = false
          this.axios.post('http://119.45.63.83:3000/users/register', this.regForm).then((res) => {
            console.log(res)
            if (res.status === 200) {
              if (res.data.status === 100) {
                console.log('suc')
                this.$alert('注册成功', '用户注册')
                // this.userName = res.data.userName
              } else {
                this.$alert('注册错误', '用户注册')
              }
            }
          })
        }
      })
    }
  },
  mounted () {
    console.log(this.$route.path)
    window.onresize = () => {
      this.screenWidth = document.body.clientWidth
    }
    // 测试menu ref
    // console.log('菜单')
    // console.log(this.$refs.mainMenu)
    this.openFullScreen2()
  },
  watch: {
    screenWidth (newValue) {
      if (!this.timer) {
        this.screenWidth = newValue
        this.timer = true
        setTimeout(
          () => {
            this.timer = false
          }, 400
        )
      }
    },
    $router: this.onRouteChanged
  },
  computed: {
    isXs: function () {
      console.log(!(this.screenWidth >= 1500))
      return !(this.screenWidth >= 1500)
    }
  }
}
</script>

<style >
body {
  display: block;
  margin: 0px;
}
#app {
  font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.el-container {
  margin: 0px 0px 0px 0px;
  padding: 0px;
}
.el-header{
  padding: 10px 10px 10px 50px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  position: fixed;
  top: 0;
  width: 100%;
  left: 0;
  background-color: #fff;
  z-index: 1001;
  // box-shadow: 0px 5px 2px -5px #333333;
}
.logo {
  width: 200px;
  height: 90px;
}
.logoTitle{
  position: absolute;
  margin-left: 120px;
  margin-top: -32px;
  font-family: "微软雅黑";
  font-size:18px ;
  color: #1294d2;
  font-weight: normal;
  letter-spacing: 3px;
}
.el-menu {
  vertical-align: bottom;
}
.el-menu.el-menu--horizontal {
  border-bottom: solid 0px #e6e6e6!important;
  font-size: 20px;
}
.menu-item {
  text-align: center;
  background-color: #306fe0;
}
.el-menu-item {
  padding: 0px 20px;
  font-size:18px;
}
.el-submenu span{
  //padding: 0px 10px;
  font-size:18px;
}
.el-menu--horizontal .el-menu .el-menu-item{
  background-color: #306fe0;
  float: none;
  height: 56px;
  line-height: 36px;
  padding: 10px 10px;
  color: #fff;
}
.el-menu-item .menu-a {
    width: 100%;
    height: 100%;
    display: block;
    text-decoration: none;
    color: #fff;
  }
  .menu-a:hover {
    width: 100%;
    /* height: -webkit-fill-available; */
    background: #fff;
    border-radius: 8px;
    color: #306fe0;
    display: block;
  }
.el-icon-user{
 font-size: 25px;
}
.el-main{
  padding: 0px;
}
.el-footer{
  padding: 0px;
}
.footer {
  background-color: #001528;
  text-align: center;
  //flex-flow: 14px;
  color: #999999;
  padding: 18px 36px;
  //line-height: 60 px;
}
.footer div {
  display: contents;
}
.footer div span {
  color: #0068b7;
}

.footer a {
  display: contents;
  padding: 5px;
  color: #fff;
  box-sizing: border-box;
}
.el-dialog-height{
  height: 500px;
}
.user-zone{
  margin: auto 0;
}
 .user-zone li{
    list-style: none;
    float: left;
 }
/*
.el-loading-spinner .circular{
  width:42px;
  height: 42px;
  animation: loading-rotate 2s linear infinite;
  display: none;
}
.el-loading-spinner{
  background: url("./assets/images/cropped-favicon-192x192.png") no-repeat;
  background: 48px 48px;
  width: 100%;
  height: 100%;
  position: relative;
  top:50%;
  left: 45%;
} */
</style>



// WEBPACK FOOTER //
// src/App.vue